<template>
  <div class="row">
    <!-- Bayad Transactions Section -->
    <div class="col-12">
      <div class="card mb-4">
        <div class="card-header pb-0">
          <div class="row">
            <div class="col-12 d-flex d-flex justify-content-between align-items-center">
              <h6 class="mb-0">Bayad Transactions</h6>
              <button
                class="btn bg-gradient-dark mb-0 ms-auto"
                :disable="bayadExportLoading"
                @click="exportBayadTransactions"
              >
                <i class="fas fa-download" v-if="!bayadExportLoading"></i>
                <div
                    class="spinner-border spinner-border-sm"
                    role="status"
                    v-if="bayadExportLoading"
                >
                    <span class="sr-only">Loading...</span>
                </div>
                Export
              </button>
            </div>
          </div>
        </div>
        <hr class="mx-3" style="border-top: 1px solid !important" />

        <bayad-transaction-list />
      </div>
    </div>
  </div>
</template>

<script>
import bayadTransactionList from "../transactions/components/bayadTransactionList.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    "bayad-transaction-list": bayadTransactionList,
  },
  computed: {
    ...mapState({
      bayadExportLoading: (state) =>
        state.retailerController.bayadTransactionsExportLoading,
    }),
  },
  methods: {
    ...mapActions({
      exportBayadTransactions: "retailerController/ExportBayadTransactions",
    }),
  },
};
</script>

<style>
</style>
